import Vue from 'vue'
import NewMessageDialog from '@/components/new_message_dialog/index'

const MessageBoxObject = Vue.extend(NewMessageDialog)

NewMessageDialog.install = function(data) {
  if ( typeof data !== 'object' || typeof data === null ) {
    throw new Error('參數類型必須為對象')
  }
  let instance = new MessageBoxObject({
    data
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
  })

  return instance.confirm()
}

export default NewMessageDialog
